import { COLUMN_ACTION, COLUMN_ACTION_TYPE, COLUMN_DEVICE, COLUMN_NAME, COLUMN_SITE, COLUMN_TIME_PATTERN } from "../../constants/column-types";
import { FILTER_ACCESS_TIME_PATTERN, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const TimeTriggeredActionColumn: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "taName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Time Pattern",
        accessor: "timePattern",
        isNumeric: false,
        id: 1,
        sortByName: "timePattern.tpName",
        sortDirection: "asc",
        active: true,
        searchOnName: "timePattern.id",
        lookupName: "timePattern.tpName",
        translationKey: "timePattern",
        columnId: COLUMN_TIME_PATTERN,
        settingDataName: "timePattern",
        filterId: FILTER_ACCESS_TIME_PATTERN
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 2,
        sortByName: "devAction.deviceImprox.devName",
        sortDirection: "asc",
        active: true,
        translationKey: "device",
        columnId: COLUMN_DEVICE,
    },
    {
        heading: "Action Type",
        accessor: "actionType",
        isNumeric: false,
        id: 3,
        sortByName: "devAction.deviceAction.actionType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "actionType",
        columnId: COLUMN_ACTION_TYPE,
    },
    {
        heading: "Action Name",
        accessor: "actionName",
        isNumeric: false,
        id: 4,
        sortByName: "devAction.setting.trnName",
        sortDirection: "asc", 
        active: true,
        translationKey: "actionName",
        columnId: COLUMN_ACTION,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 5,
        sortByName: "devAction.deviceImprox.site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "devAction.deviceAction.deviceImprox.site.id",
        lookupName: "devAction.deviceAction.deviceImprox.site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    }
];

export default TimeTriggeredActionColumn;
